import React, { useEffect, useState } from 'react';
import styles from './MerchSuccess.module.css';
import { useCart } from '../../contexts/Merch/CartContext';
import { sendGetRequest } from '../../services/api/coreApiService';
import { useLocation } from 'react-router-dom';


const getOrderDetails = async (url: string) => {
    const path = "api/Payment/verify-checkout-session?sessionId=" + url;
    const response = await sendGetRequest(path);
    console.log('response to get order numbre', JSON.stringify(response));
    return response;
};

const MerchSuccess: React.FC = () => {
    const [orderNumber, setOrderNumber] = useState<string | null>(null);

    const { clearCart } = useCart();

    const location = useLocation(); 
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');    


    useEffect(() => {
        if (!sessionId) {
            return;
        }

        const verifyPaymentStatus = async () => {
            try {
                    const response = await getOrderDetails(sessionId); 
    
                    if (response.isPaid) {
                        clearCart();
                    }

                    setOrderNumber(response.orderNumber);
            } catch(error) {
                console.error('Error verifying payment status', error);
            }
        };

        if (sessionId) {
            verifyPaymentStatus();
        }
        
    }, [sessionId]);

    return (
        <div className={styles.container}>
            <h1 className={styles.h1}>
                Thank You!
            </h1>
            {orderNumber && <p className={styles.thankYouNote}>Your Order Number: <strong>{orderNumber}</strong></p>}
            <p className={styles.thankYouNote}>
                Thank you for your purchase! Your contribution directly supports our mission to protect turtles, reduce road mortality, 
                and promote safe crossings. 
                We deeply appreciate your generosity. 
                
            </p>
            <p className={styles.thankYouNote}>
                Love, TurtlTracker
            </p>
        </div>
    );
};

export default MerchSuccess;